import { canRecallInAram } from '../../domain/map/aramRules.js';

/**
 * createRecallGateController — Gates Recall (B) by mapId (AR-05).
 * Presentation wiring; recall allow/deny via domain map rules.
 */
const RECALL_RULE_BY_MAP = {
  aram_proving_grounds: (entity) => canRecallInAram(entity)
};

export function createRecallGateController({ getMapId }) {
  function canRecall(entity) {
    const mapId = typeof getMapId === 'function' ? getMapId() : null;
    const rule = RECALL_RULE_BY_MAP[mapId];
    if (rule) return rule(entity);
    return true;
  }

  function tryRecall(entity) {
    if (!canRecall(entity)) {
      return { ok: false, reason: 'RECALL_DISABLED_ON_MAP' };
    }
    return { ok: true };
  }

  return { canRecall, tryRecall };
}
